function checkAndHideElement() {
    const drawerElement = document.getElementsByClassName('.drawer-cd-up-app-Ksl');
    const cartElement = document.getElementById('offcanvas-cart');
    
    if (drawerElement && cartElement) {
        cartElement.remove();
        if (window.checkInterval) {
            clearInterval(window.checkInterval);
        }
    }
}

window.checkInterval = setInterval(checkAndHideElement, 100);

document.addEventListener('DOMContentLoaded', checkAndHideElement);

const observer = new MutationObserver(() => {
    checkAndHideElement();
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

window.OpusNoATC = true;
(function (ns, fetch) {
  ns.fetch = function() {
    const response = fetch.apply(this, arguments);
    response.then(res => {
      const url = new URL(res.url);
      if (res.url.includes(`${window.location.origin}/cart/add`)) {
        const params = url.searchParams;
        const isOpus = params.get("opus");
        if(isOpus) return;

        window?.opusRefreshCart();
        window?.opusOpen();
      }
    });
    return response
  }
}(window, window.fetch))